import axios from 'axios';
import { useContext, useEffect } from 'react';
import SessionContext from '../contexts/SessionContext';
import API_URL from '../constants/environment';

interface RegisterCollaborationRequest {
    orderId: string;
}

interface UnregisterCollaborationRequest {
    orderId: string;
}

const registerCollaboration = async (orderId: string, sessionId: string): Promise<void> => {
    await axios.post(
        `${API_URL}/order/collaborate/register-user`,
        { orderId } satisfies RegisterCollaborationRequest,
        {
            headers: {
                Authorization: sessionId,
            },
            validateStatus: (status) => status === 200 || status === 201,
        },
    );
};

const unregisterCollaboration = async (orderId: string, sessionId: string): Promise<void> => {
    await axios.delete(`${API_URL}/order/collaborate/unregister-user`, {
        headers: {
            Authorization: sessionId,
        },
        data: { orderId } satisfies UnregisterCollaborationRequest,
        validateStatus: (status) => status === 204,
    });
};

export const useOrderCollaboration = (orderId: string | undefined) => {
    const sessionContext = useContext(SessionContext);
    const sessionId = sessionContext?.sessionId ?? null;

    useEffect(() => {
        if (!orderId || !sessionId) {
            return;
        }

        const activeOrderId = orderId;
        const activeSessionId = sessionId;

        registerCollaboration(activeOrderId, activeSessionId).catch(() => {});

        return () => {
            unregisterCollaboration(activeOrderId, activeSessionId).catch(() => {});
        };
    }, [orderId, sessionId]);
};
